import LegalDocumentPage from "./LegalDocumentPage";
import { accountDeletionDocument } from "./legalDocumentContent";

const AccountDeletion = () => {
  return <LegalDocumentPage document={accountDeletionDocument} />;
};

export default AccountDeletion;